export const css = {
	root: '_19W6CrNl',
	triggerWrapper: '_3SHFZSJh',
	' _key': 'afcpe-theme/dojo/typeahead'
};

export default css;
